import { capitalize } from '@/lib/capitalize'
import { Maybe } from '@/lib/types'
import { PersonNames } from '@/types/userNew'

export function fullName<T extends Partial<PersonNames> = Partial<PersonNames>>(u: Maybe<T>) {
	if (!u) {
		return ''
	}
	return capitalize([u.first_name, u.middle_name, u.last_name].filter(Boolean).join(' ').trim())
}

export function userInitials<T extends Partial<PersonNames> = Partial<PersonNames>>(u: Maybe<T>) {
	if (!u) {
		return ''
	}
	return [u.first_name, u.last_name]
		.filter(Boolean)
		.map((w) => w?.[0]?.toLocaleUpperCase())
		.join('')
}
